import { Select } from './gb-select';
riot.tag2('gb-native-select', '<select name="selector" onchange="{_scope.selectNative}"> <option if="{!_scope.default}" value="" selected disabled>{_scope.selectLabel()}</option> <option each="{option in _scope.options}" if="{!option.clear}" value="{optionValue(option)}">{optionLabel(option)}</option> </select>', '', '', function(opts) {
    this.optionLabel = Select.optionLabel;
    this.optionValue = Select.optionValue;
    this._scopeTo('gb-select');
});



/** WEBPACK FOOTER **
 ** ./src/tags/select/gb-native-select.tag.html
 **/